// Spec 44 design-tokens-concrete — spacing + radius tokens.
//
// SPACING is a 14-step ladder (0px → 128px) chosen so common UI gaps —
// 4 / 8 / 12 / 16 / 24 — are first-class steps with no in-between
// fudging. Component authors reach for `space_5` (16) and `space_7`
// (24); a request for "space_6_5" should fail review (use the existing
// step or escalate to add a new committed step via spec 44).
//
// RADIUS is an 8-step ladder + the sentinel `radius_pill` (9999) for
// fully rounded shapes. Tokens are integer px. Values follow the novem
// shape scale (colors_and_type.css §7) — one step rounder than the
// previous ladder; cards and panels read softer.

export const SPACING = {
  space_0: 0,
  space_1: 2,
  space_2: 4,
  space_3: 8,
  space_4: 12,
  space_5: 16,
  space_6: 20,
  space_7: 24,
  space_8: 32,
  space_9: 40,
  space_10: 56,
  space_11: 72,
  space_12: 96,
  space_13: 128,
} as const;

export type SpacingName = keyof typeof SPACING;

export const RADIUS = {
  radius_none: 0,
  radius_xs: 4,
  radius_sm: 6,
  radius_md: 10,
  radius_lg: 14,
  radius_xl: 20,
  radius_2xl: 28,
  radius_pill: 9999,
} as const;

export type RadiusName = keyof typeof RADIUS;
